export const KR_FILES_NAMES = {
  defaultSong: 'song',
  withLyrics: 'original_song',
}
